import { useTranslation } from "react-i18next";

import { getRootUrl } from "../../utils/urls";
import { MenuLinkButton } from "../partials/MenuLink";

import { doLogout } from "./LogoutMutation";

const LogoutMenuLink = ({ closeMenu, text }) => {
  const handleLogout = function () {
    doLogout(redirectPath => {
      if (closeMenu) {
        closeMenu();
      }
      if (redirectPath) {
        window.location.replace(redirectPath);
      } else {
        window.location.replace((getRootUrl() || "/") + "?lo=1");
      }
    });
  };
  const { t } = useTranslation();
  return (
    <MenuLinkButton onClick={handleLogout}>
      {text || t("nav.primary.myAccount.logout")}
    </MenuLinkButton>
  );
};

export default LogoutMenuLink;
